import {CreateDictWeaponDto, DictWeapon} from "../../../../model/Dto/Dict/Weapon";
import {ApiRequest, RequestMethod} from "../../../request";

export async function createWeapon(data: CreateDictWeaponDto): Promise<DictWeapon | null> {
    const apiRequest = new ApiRequest();
    apiRequest.setMethod(RequestMethod.POST);
    apiRequest.setUrl("/api/weapon");
    apiRequest.setJsonBody(data);
    const response: any = await apiRequest.send();
    if (response.status === 200) return response.data;
    return null;
}